import React from 'react';
import AsyncSelect from 'react-select/async';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';

interface AsyncSelectProps {
  input: object & {
    onBlur: (value: any) => void;
    value: any;
  };
  initialValue: any;
  meta: { touched: boolean; error: boolean };
  label: string;
  name: string;
  helperText?: string;
  id?: string;
  readOnly?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
  placeholder?: string;
  loadOptions: any;
  error?: any;
  touched?: any;
  isMulti?: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      marginTop: '16px',
      marginBottom: '8px',
    },
  })
);

const AsyncSelectField = ({
  input,
  loadOptions,
  variant,
  touched,
  error,
  placeholder,
  label,
  helperText,
  isMulti,
}: AsyncSelectProps) => {
  const classes = useStyles();

  return (
    <FormControl
      fullWidth
      variant={variant}
      error={touched && error}
      className={classes.formControl}
    >
      <InputLabel
        style={{
          transform: 'translate(14px, -6px) scale(0.75)',
          background: 'white',
          padding: '0 .25rem',
          zIndex: 11,
        }}
      >
        {label}
      </InputLabel>
      <AsyncSelect
        {...input}
        isMulti={isMulti}
        placeholder={placeholder}
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions
        styles={{
          container: (provided: any) => ({
            ...provided,
            zIndex: 10,
          }),
          control: (provided: any) => ({
            ...provided,
            padding: '7.5px',
            fontSize: '1rem',
          }),
        }}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {error && <FormHelperText>{touched && error}</FormHelperText>}
    </FormControl>
  );
};

export default AsyncSelectField;
